import { Radio } from "antd";
import { useTranslation } from "react-i18next";

export const DisplayTab = ({ branchSort = 'startOn', setBranchSort = (_: string) => {} }) => {

    const { t } = useTranslation();

    return <>
        <strong
            className="text-left mt-2"
            style={{ marginBottom: '0.5rem' }}
        >
            {t('pages.fishbone.display.sort.title')}
        </strong>

        <div className="text-left mb-1">
            <Radio.Group
                value={branchSort}
                onChange={(e) => setBranchSort(e.target.value)}
            >
                <Radio style={{ display: 'block', marginBottom: '0.4rem' }} value="startOn">
                    {t('pages.fishbone.display.sort.startOn')}
                </Radio>
                <Radio style={{ display: 'block', marginBottom: '0.4rem' }} value="name">
                    {t('pages.fishbone.display.sort.name')}
                </Radio>
                <Radio style={{ display: 'block' }} value="manual">
                    {t('pages.fishbone.display.sort.manual')}
                </Radio>
            </Radio.Group>
        </div>
    </>
}
